import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Day / Week / Month view switcher + prev/next arrows + "Today" jump.
 * Kept pure: the container owns `viewMode` + `viewAnchor` and the
 * bounds callbacks.
 */
export const ViewNav = ({
  viewMode, setView,
  rangeLabel,
  onPrev, onNext, onToday,
  canPrev, canNext, canGoToday,
}) => (
  <>
    <div className="segbar sched-view-switcher" role="tablist" aria-label="Schedule view">
      <button type="button" role="tab" aria-selected={viewMode === 'day'} className={`seg ${viewMode === 'day' ? 'on' : ''}`} onClick={() => setView('day')} data-testid="sched-view-day">Day</button>
      <button type="button" role="tab" aria-selected={viewMode === 'week'} className={`seg ${viewMode === 'week' ? 'on' : ''}`} onClick={() => setView('week')} data-testid="sched-view-week">Week</button>
      <button type="button" role="tab" aria-selected={viewMode === 'month'} className={`seg ${viewMode === 'month' ? 'on' : ''}`} onClick={() => setView('month')} data-testid="sched-view-month">Month</button>
    </div>

    <div className="sched-view-nav" data-testid="sched-view-nav">
      <button
        type="button" className="btn s sched-nav-arrow"
        onClick={onPrev} disabled={!canPrev}
        aria-label="Previous" data-testid="sched-nav-prev"
      >
        <ChevronLeft size={16} />
      </button>
      <span className="sched-range" data-testid="sched-range">{rangeLabel}</span>
      <button
        type="button" className="btn s sched-nav-arrow"
        onClick={onNext} disabled={!canNext}
        aria-label="Next" data-testid="sched-nav-next"
      >
        <ChevronRight size={16} />
      </button>
      {viewMode === 'day' && (
        <button
          type="button" className="btn s sched-today"
          onClick={onToday} disabled={!canGoToday}
          data-testid="sched-nav-today"
        >Today</button>
      )}
    </div>
  </>
);
